import { IConfirmPublicationRequest } from "../../../model/official-daily/request/confirm-publication-request";
import { IOfficialDiaryPagedRequest } from "../../../model/official-daily/request/official-diary-paged-request";
import { IPreviewPublicationRequest } from "../../../model/official-daily/request/preview-publication-request";
import { ICategoryPublicationResponse } from "../../../model/official-daily/response/category-publication-response";
import { IEntityPublicationResponse } from "../../../model/official-daily/response/entity-publication-response";
import { IOfficialDiaryDetailResponse } from "../../../model/official-daily/response/official-diary-detail-response";
import { IOfficialDiaryPagedResponse } from "../../../model/official-daily/response/official-diary-paged-response";
import { IPreviewPublicationResponse } from "../../../model/official-daily/response/preview-publication-response";
import { ISubCategoryPublicationResponse } from "../../../model/official-daily/response/subcategory-publication-response";
import { IListClientsRequest } from "../../../model/base/request/list-clients-request";
import { ICreateClientRequest } from "../../../model/base/request/create-client-request";
import { IUpdateClientRequest } from "../../../model/base/request/update-client-request";
import { IListClientsResponse } from "../../../model/base/response/list-clients-response";
import { IClientDetailResponse } from "../../../model/base/response/client-detail-response";
import HttpClient from "../../services/http-client";
import { PaginationResponse } from "../../../model/base/response/pagination-response";
import { FileBase64Response } from "../../../model/base/response/file-base-64-response";
import { serialize } from "object-to-formdata";
import ApplicationAppService from "../application-app-service";

const defaultPath = 'OfficialDaily';

let applicationData = ApplicationAppService.getApplicationData();

var baseUrl = applicationData.officialDailyUrl;

const list = async (params: IOfficialDiaryPagedRequest): Promise<PaginationResponse<IOfficialDiaryPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IOfficialDiaryPagedResponse>(), response.data));
};

const getById = async (id: number): Promise<IOfficialDiaryDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/${id}`
    }).then((response) => Object.assign({} as IOfficialDiaryDetailResponse, response.data));
};

const downloadFile = async (id: number): Promise<FileBase64Response> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/${id}/File/Download`
    }).then((response) => Object.assign(new FileBase64Response(), response.data));
};

const listCategories = async (): Promise<ICategoryPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Categories`
    }).then((response) => Object.assign([] as unknown as ICategoryPublicationResponse, response.data));
};
const listEntityPublication = async (): Promise<IEntityPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/EntityPublication`
    }).then((response) => Object.assign([] as unknown as IEntityPublicationResponse, response.data));
};

const listSubcategories = async (id: number): Promise<ISubCategoryPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Subcategories`,
        params: { categoryId: id }
    }).then((response) => Object.assign([] as unknown as ISubCategoryPublicationResponse, response.data));
};
const releasePublication = async (clientId: number) => {
    await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Publication/Release`,
        params: { clientId },
        cancelToken: undefined
    });
}

const close = async (officialDailyId: number) => {
    await HttpClient.executeRequest({
        method: 'put',
        baseURL: baseUrl,
        url: `/${defaultPath}/${officialDailyId}/Close`
    });
}

const changeVisibility = async (officialDailyId: number) => {
    await HttpClient.executeRequest({
        method: 'put',
        baseURL: baseUrl,
        url: `/${defaultPath}/${officialDailyId}/ChangeVisibility`
    });
}

const previewPublication = async (params: IPreviewPublicationRequest, files: File[]): Promise<IPreviewPublicationResponse> => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });


    files.forEach(file => {
        formData.append("files", file);
    });

    return await HttpClient.executeRequest({
        method: 'post',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/Publication/Preview`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then((response) => Object.assign({} as IPreviewPublicationResponse, response.data));
};

const confirmPublication = async (params: IConfirmPublicationRequest) => {
    await HttpClient.executeRequest({
        method: 'post',
        baseURL: baseUrl,
        url: `/${defaultPath}/Publication/Confirm`,
        data: params,
    });
};


const OfficialDiaryAppService = {
    list, getById, downloadFile, listCategories, close, changeVisibility, listSubcategories, listEntityPublication, confirmPublication, previewPublication, releasePublication
};

export default OfficialDiaryAppService;